import { render, staticRenderFns } from "./school3.vue?vue&type=template&id=18da5b9c&scoped=true&"
import script from "./school3.vue?vue&type=script&lang=js&"
export * from "./school3.vue?vue&type=script&lang=js&"
import style0 from "./school3.vue?vue&type=style&index=0&id=18da5b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da5b9c",
  null
  
)

export default component.exports